import script from "./AstrobinCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AstrobinCard.vue?vue&type=script&setup=true&lang=js"

import "./AstrobinCard.vue?vue&type=style&index=0&id=68c2b964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68c2b964"]])

export default __exports__